import { render, staticRenderFns } from "./HumanDate.vue?vue&type=template&id=116c360a"
import script from "./HumanDate.vue?vue&type=script&lang=js"
export * from "./HumanDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports